import { Injectable, inject } from "@angular/core";

import { EmailShare } from "@tylertech/shared-module";
import { IAggregate, ICardData, ICardAction, ActionType } from "@tylertech/tyler-api-types";

import { AggregateActionResult, AggregateHelperService } from "../services";

@Injectable()
export class ShareActionHandler implements ShareActionHandler
{
    private readonly $aggregateHelperService = inject(AggregateHelperService);


    predicate(_aggregate: IAggregate, _cardData: ICardData, action: ICardAction): boolean
    {
        return action.actionType === ActionType.Share;
    }

    execute(aggregate: IAggregate, cardData: ICardData, _action: ICardAction): Promise<AggregateActionResult>
    {
        const email = this.$aggregateHelperService.getFieldValue(cardData, "Email");
        const emailSubject = this.$aggregateHelperService.getFieldValue(cardData, "EmailSubject");
        const emailBody = this.$aggregateHelperService.getFieldValue(cardData, "EmailBody");

        // This will URL encode the message and send it
        EmailShare.send({
            recipient: !email ? "" : email,
            subject: !emailSubject ? aggregate.Name : emailSubject,
            message: `${!emailBody ? "" : emailBody}`
        });

        return Promise.resolve(true);
    }

    load(_aggregate: IAggregate, _cardData: ICardData, _action: ICardAction): void
    {
        /* NO_OP */
    }
}
